import { Box, Container, Link, Typography } from "@mui/material";

const colors = {
    cream: "#fffaf2",
    sand: "#f7f1e8",
    paper: "rgba(255, 250, 242, 0.9)",
    ink: "#2a2621",
    muted: "rgba(42, 38, 33, 0.68)",
    brown: "#9b7653",
    brownDark: "#6f5136",
};

function SectionTitle({ children }) {
    return (
        <Typography
            component="h2"
            sx={{
                mt: 5,
                mb: 2,
                fontFamily: '"Quicksand", sans-serif',
                fontSize: {
                    xs: "1.7rem",
                    md: "2.1rem",
                },
                lineHeight: 1.15,
                fontWeight: 700,
                letterSpacing: "-0.04em",
                color: colors.ink,
            }}
        >
            {children}
        </Typography>
    );
}

function TextBlock({ children }) {
    return (
        <Typography
            sx={{
                mb: 2,
                fontFamily: '"Nunito Sans", sans-serif',
                fontSize: {
                    xs: 16,
                    md: 17,
                },
                lineHeight: 1.8,
                color: colors.muted,
            }}
        >
            {children}
        </Typography>
    );
}

function Impressum() {
    return (
        <Box
            component="main"
            sx={{
                minHeight: "100vh",
                py: {
                    xs: 10,
                    md: 14,
                },
                background:
                    "linear-gradient(180deg, #fffaf2 0%, #f7f1e8 55%, #eef7fa 100%)",
            }}
        >
            <Container
                maxWidth={false}
                sx={{
                    width: "100%",
                    maxWidth: 980,
                    mx: "auto",
                    px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                    },
                }}
            >
                <Box
                    sx={{
                        p: {
                            xs: 3,
                            sm: 4,
                            md: 6,
                        },
                        borderRadius: {
                            xs: 5,
                            md: 7,
                        },
                        backgroundColor: colors.paper,
                        border: "1px solid rgba(155,118,83,0.15)",
                        boxShadow: "0 24px 80px rgba(78,54,30,0.09)",
                    }}
                >
                    <Typography
                        component="p"
                        sx={{
                            mb: 1.2,
                            fontFamily: '"Nunito Sans", sans-serif',
                            fontSize: 13,
                            fontWeight: 900,
                            letterSpacing: "0.17em",
                            textTransform: "uppercase",
                            color: colors.brown,
                        }}
                    >
                        Rechtliches
                    </Typography>

                    <Typography
                        component="h1"
                        sx={{
                            mb: 4,
                            fontFamily: '"Quicksand", sans-serif',
                            fontSize: {
                                xs: "2.6rem",
                                sm: "3.4rem",
                                md: "4.4rem",
                            },
                            lineHeight: 0.98,
                            fontWeight: 700,
                            letterSpacing: "-0.06em",
                            color: colors.ink,
                        }}
                    >
                        Impressum
                    </Typography>

                    <SectionTitle>Angaben gemäß § 5 TMG</SectionTitle>

                    <TextBlock>
                        <strong>Vertreten durch:</strong>
                        <br />
                        Claudia Don
                        <br />
                        Lange Straße 37
                        <br />
                        26434 Hooksiel
                    </TextBlock>

                    <TextBlock>
                        <strong>Kontakt:</strong>
                        <br />
                        Telefon:{" "}
                        <Link
                            href="tel:+494425353"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            04425 - 353
                        </Link>
                        <br />
                        E-Mail:{" "}
                        <Link
                            href="mailto:info@hooksieler-laedchen.de"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,
                                wordBreak: "break-word",

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            info@hooksieler-laedchen.de
                        </Link>
                    </TextBlock>

                    <SectionTitle>Haftungsausschluss</SectionTitle>

                    <SectionTitle>Haftung für Inhalte</SectionTitle>

                    <TextBlock>
                        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
                        Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
                        können wir jedoch keine Gewähr übernehmen. Als Dienstanbieter sind
                        wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach
                        den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind
                        wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte
                        oder gespeicherte fremde Informationen zu überwachen oder nach
                        Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                        hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung
                        von Informationen nach den allgemeinen Gesetzen bleiben hiervon
                        unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                        Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                        Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
                        diese Inhalte umgehend entfernen.
                    </TextBlock>

                    <SectionTitle>Haftung für Links</SectionTitle>

                    <TextBlock>
                        Unser Angebot enthält Links zu externen Webseiten Dritter, auf
                        deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                        diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte
                        der verlinkten Seiten ist stets der jeweilige Anbieter oder
                        Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden
                        zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
                        Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
                        erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten
                        Seiten ist jedoch ohne konkrete Anhaltspunkte einer
                        Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
                        Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                    </TextBlock>

                    <SectionTitle>Urheberrecht</SectionTitle>

                    <TextBlock>
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                        diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                        Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                        Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                        schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                        Downloads und Kopien dieser Seite sind nur für den privaten, nicht
                        kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser
                        Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
                        Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
                        gekennzeichnet. Sollten Sie trotzdem auf eine
                        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
                        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
                        werden wir derartige Inhalte umgehend entfernen.
                    </TextBlock>

                    <SectionTitle>
                        Pflichtinformation nach der Verordnung (EU) Nr. 524/2013
                    </SectionTitle>

                    <TextBlock>
                        Link zur Homepage der Stelle für die Online-Beilegung
                        verbraucherrechtlicher Streitigkeiten der Europäischen Kommission:{" "}
                        <Link
                            href="http://ec.europa.eu/consumers/odr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,
                                wordBreak: "break-word",

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            http://ec.europa.eu/consumers/odr/
                        </Link>{" "}
                        - weiterführende Informationen stehen Ihnen dort voraussichtlich ab
                        dem 15.02.2016 zur Verfügung. Für erste Fragen zu einer möglichen
                        Streitschlichtung stehen wir Ihnen unter{" "}
                        <Link
                            href="mailto:info@hooksieler-laedchen.de"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,
                                wordBreak: "break-word",

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            info@hooksieler-laedchen.de
                        </Link>{" "}
                        zur Verfügung.
                    </TextBlock>

                    <SectionTitle>
                        Mandatory information according to Regulation (EU) No 524/2013
                    </SectionTitle>

                    <TextBlock>
                        Follow this link to the website of the European Commission’s entity
                        for online dispute resolution for consumer disputes:{" "}
                        <Link
                            href="http://ec.europa.eu/consumers/odr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,
                                wordBreak: "break-word",

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            http://ec.europa.eu/consumers/odr/
                        </Link>{" "}
                        - further information is expected to be available there from 15
                        February 2016. Should you have any initial questions concerning a
                        potential dispute resolution, please email us at{" "}
                        <Link
                            href="mailto:info@hooksieler-laedchen.de"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,
                                wordBreak: "break-word",

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            info@hooksieler-laedchen.de
                        </Link>
                        .
                    </TextBlock>
                </Box>
            </Container>
        </Box>
    );
}

export default Impressum;